import { render, staticRenderFns } from "./Quacks.vue?vue&type=template&id=63044d72"
import script from "./Quacks.vue?vue&type=script&lang=js"
export * from "./Quacks.vue?vue&type=script&lang=js"
import style0 from "./Quacks.vue?vue&type=style&index=0&id=63044d72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports